"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownActionType = void 0;
var DropdownActionType;
(function (DropdownActionType) {
    DropdownActionType["CUSTOM_ACTION"] = "CUSTOM_ACTION";
    DropdownActionType["CLIPBOARD_COPY"] = "CLIPBOARD_COPY";
    DropdownActionType["LINK"] = "LINK";
})(DropdownActionType || (exports.DropdownActionType = DropdownActionType = {}));
//# sourceMappingURL=dropdown.js.map